import React, { useState, useEffect } from 'react'
import whisprLogo from '../images/logo.png'

export default function Footer() {
	const baseGooglePlayUrl =
		'https://play.google.com/store/apps/details?id=com.guppir.whispr'
	const appStoreLink =
		'https://apps.apple.com/app/apple-store/id1612446646?pt=122259015&ct=whispr_reply&mt=8'
	const [googlePlayUrl, setGooglePlayUrl] = useState(baseGooglePlayUrl)
	const isIOS =
		typeof navigator !== 'undefined'
			? /(iPad|iPhone|iPod|iOS|OS)/i.test(navigator.userAgent)
			: false

	useEffect(() => {
		const queryString = window.location.search
		if (queryString) {
			setGooglePlayUrl(
				`${baseGooglePlayUrl}&referrer=${encodeURIComponent(
					queryString.substring(1)
				)}`
			)
		}
	}, [])

	const href = isIOS ? appStoreLink : googlePlayUrl
	return (
		<>
			<footer style={footerStyles}>
				<p style={footerParagraphStyles}>Posted from </p>
				<a href={href} style={lingkStyle}>
					<img
						src={whisprLogo}
						alt='whispr-logo'
						style={footerLogoStyles}
					></img>
				</a>
			</footer>
		</>
	)
}

const footerStyles = {
	position: 'absolute',
	bottom: 0,
	left: 0,
	right: 0,
	width: '100%',
	padding: '10px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	gap: 5
}
const lingkStyle = {
	lineHeight: '12px'
}

const footerLogoStyles = {
	height: '21px'
}

const footerParagraphStyles = {
	fontSize: '12px'
}
